const key = 'urun_tarihce';

export const saveHistory = (params, data) => {
  try {
    const historyObj = {
      KUL_MODEL_KODU: params.KUL_MODEL_KODU,
      UYIL: params.UYIL,
      UDONEM: params.UDONEM,
      SERINO: params.SERINO,
      NITELIK_KODU: params.NITELIK_KODU,
      DATE: new Date(),
      DATA: data,
    };
    let historyAll = loadHistoryAll();
    historyAll = [...historyAll, historyObj];
    localStorage.removeItem(key);
    localStorage.setItem(key, JSON.stringify(historyAll));
  } catch (error) {
 
  }
};

export const loadHistory = (params) => {
  try {
    const historyAll = loadHistoryAll();
    const filtered = historyAll.filter((h) => h.KUL_MODEL_KODU === params.KUL_MODEL_KODU
            && h.UYIL === params.UYIL
            && parseInt(h.UDONEM) === parseInt(params.UDONEM)
            && parseInt(h.SERINO) === parseInt(params.SERINO)
            && parseInt(h.NITELIK_KODU) === parseInt(params.NITELIK_KODU));
    if (filtered.length === 0) { // localde yok. Return empty.
      return [];
    }
    if (filtered.length > 1) {
      removeHistory(params);
      return [];
    }
    const history = filtered[0];
    const now = new Date();
    const ld = new Date(history.DATE); // Last Date
    if (now.getYear() === ld.getYear() && now.getMonth() === ld.getMonth() && now.getDate() === ld.getDate()) {
      return history.DATA;
    }
    removeHistory(params);
    return [];
  } catch (error) {
    return [];
  }
};


// /////////// HELPER METHODS (NOT EXPORTED) /////////////////////

// localstorage'daki tüm history leri getirir.
const loadHistoryAll = () => {
  try {
    let historyTxt = localStorage.getItem(key);
    if (historyTxt === null) {
      localStorage.setItem(key, '[]');
      historyTxt = '[]';
    }
    return JSON.parse(historyTxt);
  } catch (error) {
    return [];
  }
};


const removeHistory = (params) => {
  try {
    const historyAll = loadHistoryAll();
    const otherHistory = historyAll.filter((h) => !(h.KUL_MODEL_KODU === params.KUL_MODEL_KODU
                && h.UYIL === params.UYIL
                && h.UDONEM === params.UDONEM
                && h.SERINO === params.SERINO
                && h.NITELIK_KODU === params.NITELIK_KODU));
    localStorage.setItem(key, JSON.stringify(otherHistory));
    return true;
  } catch (error) {
    return false;
  }
};
